/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheCageGameAssets} from "../TheCageGameAssets";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap";
import {TheCage} from "../TheCage";
import {TheCageGameMode} from "../server/TheCageGameMode";
import {TheCageModel} from "../server/TheCageModel";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";

export class TheCageBackgroundElements extends PIXI.Container implements StageLayer {

    private fullImageContainer:PIXI.Container;
    private main:PIXI.Container;
    private baseGame:PIXI.Sprite;
    private baseGameEffects:PIXI.spine.Spine;
    private _mainView:PIXI.Container;
    private freespinBackgrounds:PIXI.spine.Spine[];
    private fsBackOutOverlay:PIXI.Sprite;
    private currentBg:PIXI.Container | PIXI.spine.Spine;
    private logo:PIXI.Sprite;
    private isFreespin: boolean;

    constructor() {
        super();
        this.name = "TheCageBackgroundElements";
        this.init();
    }

    public getBounceShake():gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(gsap.to(this.currentBg, {duration:0.05, x:356, y:363}));
        tl.add(gsap.to(this.currentBg, {duration:0.05, x: 360, y:360}));

        return tl;
    }

    private init() {
        this._mainView = new PIXI.Container();
        this.fullImageContainer = new PIXI.Container();

        this.baseGame = new PIXI.Sprite(TheCageGameAssets.MAIN_GAME_BACKGROUND_TEXTURE)
        this.baseGame.anchor.set(0.5,0.5);
        this.baseGameEffects = new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.BASEGAME_BACKGROUND_EFFECTS));
        this.baseGameEffects.state.setAnimation(0, "idle", true);

        this.main = new PIXI.Container();
        this.main.position.set(360, 360);
        this.main.addChild(this.baseGame);
        this.main.addChild(this.baseGameEffects);

        this.freespinBackgrounds = [
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.FREESPINS_BACKGROUND_LVL1)),
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.FREESPINS_BACKGROUND_LVL2)),
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.FREESPINS_BACKGROUND_LVL3)),
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.FREESPINS_BACKGROUND_LVL4)),
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.FREESPINS_BACKGROUND_LVL5)),
        ];
        this.freespinBackgrounds.forEach((bg) => {
            bg.position.set(360, 360);
            bg.alpha = 0;
            bg.state.addAnimation(0, "idle", true, 0);
        });

        const fsOverlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        fsOverlay.tint = PIXI.utils.string2hex("#390a06");
        fsOverlay.alpha = 0.4;
        fsOverlay.width = this.freespinBackgrounds[0].width;
        fsOverlay.height = this.freespinBackgrounds[0].height;
        fsOverlay.anchor.set(0.5,0.5);
        this.freespinBackgrounds.forEach((bg) => {bg.addChild(fsOverlay);});

        this.fsBackOutOverlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.fsBackOutOverlay.tint = PIXI.utils.string2hex("#000000");
        this.fsBackOutOverlay.alpha = 0.0;
        this.fsBackOutOverlay.width = this.freespinBackgrounds[0].width;
        this.fsBackOutOverlay.height = this.freespinBackgrounds[0].height;
        this.fsBackOutOverlay.anchor.set(0.5,0.5);
        this.freespinBackgrounds.forEach((bg) => {bg.addChild(this.fsBackOutOverlay);});

        this.fullImageContainer.addChild(this.main);
        this.fullImageContainer.position.set(0, 0);

        this._mainView.addChild(this.fullImageContainer);
        this.addChild(this._mainView);

        this.logo = new PIXI.Sprite(ImgLoader.getImgTexture(TheCageGameAssets.IMAGES_LOGO));
        this.logo.scale.set(0.65,0.65);
        this.logo.anchor.set(0.5,0.5);
        this.logo.visible = true;
        this._mainView.addChild(this.logo);

        this.onOrientationChanged();
        this.onResize();
    }

    public onOrientationChanged() {

    }

    public onResize() {
        if (NolimitApplication.isLandscape){
            if (this.isFreespin) {
                this.logo.scale.set(0.5,0.5);
                this.logo.position.set(50, 50);
                this.logo.visible = true;
            } else {
                this.logo.scale.set(0.65,0.65);
                this.logo.position.set(-70, 80);
                this.logo.visible = NolimitApplication.screenBounds.left < (-70 - this.logo.width/2);
            }
        }
        else {
            this.logo.scale.set(1,1);
            this.logo.position.set(360, -140);
            this.logo.visible = NolimitApplication.screenBounds.top < (-140 - this.logo.height/2);
        }
    }

    hideLogo(duration:number = 0.1) {
        const tl = gsap.timeline();

        tl.add(gsap.to(this.logo, {duration:duration, alpha:0, ease:"none"}));
        tl.add(() => { this.logo.visible = false; });
        tl.add(() => {this.onResize()});
        return tl;
    }

    showLogo(duration:number = 0.1):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {this.onResize()});
        tl.add(() => {
            this.logo.visible = true;
        });
        tl.add(gsap.to(this.logo, {duration:duration, alpha:1, ease:"none"}));
        return tl;
    }

    private swapBackground(newBackground:PIXI.Container | PIXI.spine.Spine, duration:number):void {
        if (newBackground == this.currentBg){
            return;
        }
        this.currentBg = newBackground;
        newBackground.alpha = 0;
        this.fullImageContainer.addChild(newBackground);
        const tl = gsap.timeline();
        tl.add(gsap.to(newBackground, {duration:duration, alpha:1}));

        tl.add(()=>{
            this.fullImageContainer.removeChildren(0);
            this.fullImageContainer.addChild(newBackground);
        });
    }

    public setMode(mode:string, duration:number = 0.001) {
        if (mode == GameMode.FREESPIN || mode == TheCageGameMode.FREESPIN_AVALANCHE) {
            const featureBuyLevel = TheCage.model.data.wasFeatureBuy ? TheCage.model.data.fsLevelEnterWith : 0;

            // TODO maybe think over this again, whats the point of sending in the mode if we check it here anyway
            if (TheCage.model.data.mode == GameMode.NORMAL || TheCage.model.data.mode == TheCageGameMode.NORMAL_AVALANCHE) {
                this.swapBackground(this.freespinBackgrounds[TheCage.model.data.fsLevel + featureBuyLevel], duration);
            } else {
                this.swapBackground(this.freespinBackgrounds[TheCage.model.data.fsLevel + 1], duration);
            }
        } else {
            this.swapBackground(this.main, duration)
        }
        this.isFreespin = (mode == TheCageGameMode.FREESPIN);
    }

    public restoreFreespins():void {
        this.isFreespin = true;
        this.onResize();
        this.swapBackground(this.freespinBackgrounds[TheCage.model.data.fsLevel], 0.001);
    }
}